<wr-new-data-table headerText="Wartungstimer"
                   localStorageIdentifier="internal-maintenance-timer-overview"
                   [loadItemsFunction]="loadMaintenanceTimers"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToMaintenanceTimer($event)"
                   [form]="form">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="datePicker">Zeitraum</label>
          <wr-date-range-picker id="datePicker" formControlName="selectedRange"
                                [showTodayButton]="true"></wr-date-range-picker>
        </div>
        <div class="filter-control-group">
          <label class="label" for="equipmentSelect">TGA Baupläne</label>
          <wr-tga-type-select id="equipmentSelect" formControlName="equipment"></wr-tga-type-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="creatorTenantSelect">Firmen</label>
          <wr-tenant-select id="creatorTenantSelect"
                            formControlName="creatorTenantId"
                            [tenantType]="TenantTypeEnum.Internal"
                            [showEmptyOption]="true"></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="ownerTenantId">Kunden</label>
          <wr-tenant-select id="ownerTenantId"
                            formControlName="ownerTenantId"
                            [tenantType]="TenantTypeEnum.External"
                            [showEmptyOption]="true"></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="buildingSelect">Gebäude</label>
          <wr-building-select id="buildingSelect"
                              formControlName="building"
                              [tenantId$]="form.get('ownerTenantId')?.valueChanges">
          </wr-building-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-entity
    key="equipmentName"
    exportKey="buildingEquipment.equipment.name"
    [sortable]="false"
    display="TGA Bauplan">
    <wr-tga-type-badge [tgaType]="entity.buildingEquipment.equipment"></wr-tga-type-badge>
  </ng-template>
  <ng-template dataColumn
               display="Dauer"
               key="durationDays"
               let-entity>
    {{ entity.durationDays }} {{ entity.durationDays | pluralize: 'Tag': 'Tage' }}
  </ng-template>
  <ng-template dataColumn
               display="Fälligkeitsdatum"
               key="nextDate"
               let-entity>
    {{ entity.nextDate | date: 'dd.MM.yyyy' }}
  </ng-template>
  <ng-template [sortable]="true"
               dataColumn
               display="Fällig in"
               key="nextDate"
               [exportValue]="exportDueDays"
               let-entity>
    <div class="due-days" [class.overdue]="dueDays(entity.nextDate) <= 0">
      {{ dueDays(entity.nextDate) }} {{ dueDays(entity.nextDate) | pluralize: 'Tag': 'Tage' }}
    </div>
  </ng-template>
  <ng-template dataColumn
               display="Gebäudeadresse"
               [sortable]="false"
               key="sectionText"
               exportKey="buildingEquipment.sectionText"
               let-entity>
    {{ entity.buildingEquipment.sectionText }}
  </ng-template>
  <ng-template dataColumn
               display="Firma"
               [sortable]="false"
               key="creatorTenant"
               exportKey="buildingEquipment.creatorTenant.name"
               let-entity>
    <wr-tenant-badge [tenant]="entity.buildingEquipment.creatorTenant"></wr-tenant-badge>
  </ng-template>
</wr-new-data-table>
